// Firebase web app configuration
export const firebaseConfig = {
  apiKey: "AIzaSyASuSpKlErBr3KzvApvaGrZy6qFLxITXws",
  authDomain: "personal-blog-72c0a.firebaseapp.com",
  projectId: "personal-blog-72c0a",
  storageBucket: "personal-blog-72c0a.firebasestorage.app",
  messagingSenderId: "1088696541263",
  appId: "1:1088696541263:web:902a8044bf6948795c8a3a",
  measurementId: "G-27ESNNTE4C"
};

let app, db, auth, storage;

if (typeof window !== "undefined" && window.firebase) {
  // Only initialize if not already initialized
  app = window.firebase.apps.length ? window.firebase.app() : window.firebase.initializeApp(firebaseConfig);
  
  if (typeof window.firebase.firestore === "function") {
    db = window.firebase.firestore();
  }
  if (typeof window.firebase.auth === "function") {
    auth = window.firebase.auth();
  }
  if (typeof window.firebase.storage === "function") {
    storage = window.firebase.storage();
  }
} else {
  console.warn("Firebase SDK not found on window. Ensure Firebase scripts are loaded in the HTML page.");
}

export { app, db, auth, storage };
